import get from "lodash/get"

export const env=process.env.REACT_APP_STAGE

export const SERVER_URL={
    DEV:"https://dev-api.dslmonitoring.net/",
    UAT:"https://uat-api.dslmonitoring.net/",
    TEST:"https://test-api.dslmonitoring.net/",
    TEST_START:"https://test-api.dslmonitoring.net/",
    PROD:"https://api.dslmonitoring.net/"
}
export const CUBS_SERVER_URL={
    DEV:"https://cubs-dev-api.dslmonitoring.net/",
    UAT:"https://cubs-uat-api.dslmonitoring.net/",
    TEST:"https://cubs-uat-api.dslmonitoring.net/",
    TEST_START:"https://cubs-uat-api.dslmonitoring.net/",
    PROD:"https://cubs-api.dslmonitoring.net/"
}
const TYPE_URL = {
    auth:'auth/'
}

export const LOGIN_URL = ()=> get(TYPE_URL,"auth")+"login"
export const SAMPLE_URL = ()=> get(TYPE_URL,"auth")+"sample"
export const FIRST_TIME_CHANGE_PASSWORD_URL = ()=> get(TYPE_URL,"auth")+"firstime-change-password"
export const CHANGE_PASSWORD_URL = ()=> get(TYPE_URL,"auth")+"change-password"
export const RESET_PASSWORD_URL = ()=> get(TYPE_URL,"auth")+"reset-password"
export const CONFIRM_RESET_PASSWORD_URL = ()=> get(TYPE_URL,"auth")+"confirm-reset-password"
export const FETCH_MFA_SCAN_BAR_URL = ()=> get(TYPE_URL,"auth")+"mfa-setup"
export const MFA_SETUP_CODE_VERIFY_URL = ()=> get(TYPE_URL,"auth")+"mfa-first-time-confirm-token"
export const MFA_OTP_CODE_VERIFY_URL = ()=> get(TYPE_URL,"auth")+"mfa-verify-token"
export const CLR_PRESIGN_URL = ()=> get(CUBS_SERVER_URL,env)+"cubs-dsl-device-prod-download-banfile"
export const LOGOUT_URL = ()=> get(TYPE_URL,"auth")+"logout"
export const VALIDATE_SESSION_URL = ()=> get(TYPE_URL,"auth")+"validate-session"
export const REFRESH_TOKEN_URL = ()=> get(TYPE_URL,"auth")+"refresh-session"